<template>
  <div class="about-us">
    <h1>关于我们</h1>
    <h2>
      公司简介：成都市觅之得科技有限公司成立于2021年09月24日，致力于陌生人社交服务领域多年，为广大单身男女提供安全、绿色、靠谱、稳定的交友平台。快速解决脱单难题。
    </h2>
    <p>
      悠悠我心APP：悠悠我心APP是一款同城附近、年轻人速配交流的交友软件。
    </p>
    <div>
      <p>产品特色</p>
      <ul>
        <li>【在线聊天】：在线一对一聊天，真实面对面，发现身边精彩；</li>
        <li>【同城交友】：看看附近的人，快速搭讪约见面，简单高效；</li>
        <li>【私密单聊】：百万附近男女24小时在线，文字、图片、聊天。</li>
        <li>
          【在线精彩推荐】：一键定位，快速匹配附近的在线异性，认识有趣的灵魂。
        </li>
      </ul>
      <p>悠悠我心，一款真人的社交app，你喜欢的都在这里。快来加入吧！！！</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.about-us {
  width: 59%;
  margin: 0 auto;
  font-size: 16px;
  color: #333;
  text-align: left;
  h1 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  h2 {
    font-weight: normal;
    margin-bottom: 40px;
  }
  p {
    margin-bottom: 10px;
  }
  div {
    ul {
      margin-top: 10px;
      li {
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue